export default __webpack_public_path__ + "f0f52dd2a61fb0307c070337efc181f9.svg";